import * as common from './controllers-common';

export default common.controllerWithoutSpecificCalculations;
